<template>
  <div class="thank-you-page">
    <header-purchase :title="event.title"
                     :start-date="event.start_date"
                     :end-date="event.end_date"
                     :type="event.type"
                     :venue="event.venue" />
    <steps :active="3" />
    <h3 v-if="!purchase.has_some_ticket_with_customization_allowed && !purchase.oxxo_reference"
        class="container">{{ $t('thankYouPage.3graciasPorTuCompra') }}</h3>
    <h3 v-else-if="purchase.oxxo_reference"
        class="container">{{ $t('thankYouPage.3graciasPorTuReserva') }}</h3>
    <h3 v-else-if="purchase.has_some_ticket_with_customization_allowed"
        class="container">{{ $t('thankYouPage.3compraRealizadaCorrectamente') }}</h3>
    <div class="thank-you-page-container-top-image container">
      <h3 v-if="!purchase.has_some_ticket_with_customization_allowed"
          class="thank-you-page-top-title tAc">{{ $t('thankYouPage.aquiEstanTusEntradas') }}</h3>
      <h3 v-else-if="purchase.oxxo_reference"
          class="thank-you-page-top-title tAc">{{ $t('thankYouPage.ahoraSoloTeFaltaIrATuOxxo') }}</h3>
      <h3 v-else-if="purchase.has_some_ticket_with_customization_allowed"
          class="thank-you-page-top-title tAc">{{ $t('thankYouPage.ahoraSoloFalta') }}</h3>
      <p v-if="!purchase.has_some_ticket_with_customization_allowed"
         class="thank-you-page-top-text small tAc">{{ $t('thankYouPage.comparteElConciertoConTusAmigos') }}
        <social-share :show-text="false"
                      :inline="true"
                      :url="event.canonical" />
      </p>
      <a v-if="purchase.has_some_ticket_with_customization_allowed && !purchase.oxxo_reference"
         :href="purchase.web_customization_url | permalinkfilter($store.state.initial.detail.wegow_direct)"
         target="_blank"
         class="btn opacity mB20">{{ $t('thankYouPage.personalizar') }}</a>
      <p v-if="purchase.has_some_ticket_with_customization_allowed && !purchase.oxxo_reference"
         class="thank-you-page-top-text tAc"
         v-html="$t('thankYouPage.teHemosEnviadoUnEmail', { email: user.email, day: day, month: month, year: year, time: time })" />
      <p v-if="user.id && !purchase.has_some_ticket_with_customization_allowed && !purchase.oxxo_reference"
         class="thank-you-page-top-text tAc"
         v-html="$t('thankYouPage.tusEntradasEnviadas', { email: user.email } ) " />
      <p v-if="purchase.buyer && !purchase.has_some_ticket_with_customization_allowed && !purchase.oxxo_reference"
         class="thank-you-page-top-text tAc"
         v-html="$t('thankYouPage.tusEntradasEnviadasUnete', { email: purchase.buyer.email } ) " />
      <p v-if="purchase.oxxo_reference"
         class="thank-you-page-top-text tAc"
         v-html="$t('thankYouPage.teHemosEnviadoUnEmailConLasInstrucciones', { email: purchase.buyer ? purchase.buyer.email : user.email })" />
      <div class="thank-you-page-top-buttons">
        <p v-if="purchase.oxxo_reference"
           class="thank-you-page-top-oxxo-reference">{{ purchase.oxxo_reference }}</p>
        <p v-if="purchase.insurance"
           v-html="$t('thankYouPage.hasContratadoElSeguroDeNoAsistencia')" />
        <a v-if="!purchase.has_some_ticket_with_customization_allowed && !purchase.oxxo_reference"
           :href="purchase.download_url"
           target="_blank"
           class="btn opacity">{{ $t('thankYouPage.verEntradas') }}</a>
        <b-button v-if="showOnboarding"
                  type="button"
                  class="opacity"
                  @click="finishOnboarding()">{{ $t('thankYouPage.terminarRegistro') }}</b-button>
        <b-button v-if="purchase.buyer"
                  class="opacity"
                  @click="openSignup()">{{ $t('thankYouPage.uneteAWegow') }}</b-button>
      </div>
    </div>
    <div v-if="event.accommodation || event.transport || event.insurance"
         class="thank-you-page-container container">
      <p class="thank-you-page-container-title">{{ $t('thankYouPage.yaTienesElPlanOrganizadoParaTuConcierto') }}</p>
      <div class="thank-you-page-blocks">
        <div v-if="event.accommodation"
             class="accommodation">
          <b-img :src="require('@/assets/images/ico_alojamiento.svg')"
                 fluid
                 :alt="event.accommodation.service" />
          <p>{{ $t('thankYouPage.buscaYReservaElAlojamiento') }}</p>
          <b-button v-if="event.accommodation.service === 'airbnb'"
                    class="white"
                    @click="openAirbnb">
            {{ $t('thankYouPage.buscarAlojamiento') }}
          </b-button>
          <b-button v-else-if="event.accommodation.service === 'stay'"
                    class="white"
                    @click="openStay">
            {{ $t('thankYouPage.buscarAlojamiento') }}
          </b-button>
        </div>
        <div v-if="event.transport"
             class="transport">
          <b-img :src="require('@/assets/images/ico_avion.svg')"
                 fluid
                 :alt="event.transport.service" />
          <p>{{ $t('thankYouPage.teOfrecemosLaFormaMasSencillaDeViajar') }}</p>
          <a v-if="event.transport.url"
             target="_blank"
             class="btn white"
             :href="event.transport.url">
            {{ $t('thankYouPage.buscarTransporte') }}
          </a>
        </div>
        <div v-if="event.insurance"
             class="insurance">
          <b-img :src="require('@/assets/images/ico_seguros.svg')"
                 fluid
                 alt="Caser" />
          <p>{{ $t('thankYouPage.disfrutaDelConciertoYDespreocupateDeTodoLoDemas') }}</p>
          <a href="https://www.wegow.com/es-es/asegura-tu-entrada/pago"
             :title="$t('userTickets.descargarEntradas')"
             class="btn white">{{ $t('thankYouPage.aseguraTuEntrada') }}</a>
        </div>
      </div>
    </div>
    <banner-caser v-else-if="!purchase.insurance && event.insurance" />
    <banner-download-app />
    <airbnb-modal v-if="showAirbnb"
                  :accommodation="event.accommodation"
                  @closeAirbnb="showAirbnb = false" />
    <stay-modal v-if="showStay"
                :accommodation="event.accommodation"
                :place="'aid=wegow-thanks'"
                @closeAirbnb="showStay = false" />
    <loader v-show="loading"
            class="load-more-loader"
            :middle="true" />
  </div>
</template>

<script>
import SocialShare from '@/components/social-share/SocialShare.vue'
import HeaderPurchase from '@/components/header-purchase/HeaderPurchase.vue'
import AirbnbModal from '@/components/airbnb/AirbnbModal.vue'
import StayModal from '@/components/stay/StayModal.vue'
import Loader from '@/components/loader/Loader.vue'
import BannerDownloadApp from '@/components/banner-download-app/BannerDownloadApp.vue'
import BannerCaser from '@/components/banner-caser/BannerCaser.vue'
import Steps from '@/components/steps/Steps.vue'

export default {
  layout: 'simple',
  components: {
    SocialShare,
    BannerDownloadApp,
    BannerCaser,
    HeaderPurchase,
    AirbnbModal,
    StayModal,
    Loader,
    Steps
  },
  data() {
    return {
      showOnboarding: false,
      showAirbnb: false,
      showStay: false,
      loading: true,
      day: undefined,
      month: undefined,
      year: undefined,
      time: undefined
    }
  },
  computed: {
    itunesRegion() {
      return this.$route.params.region
    },
    event() {
      return this.$store.state.event.detail
    },
    purchase() {
      return this.$store.state.purchase.detail
    },
    user() {
      return this.$store.state.user.detail
    }
  },
  async created() {
    await this.$store.dispatch('purchase/detail', {
      reference: this.$route.params.reference
    })
  },
  async mounted() {
    this.loading = false
    if (this.$store.state.event.detail.id)
    if (this.$store.state.purchase.detail.customization_free_datetime) {
      this.day = this.$moment(
        this.$store.state.purchase.detail.customization_free_datetime
      ).format('DD')
      this.month = this.$moment(
        this.$store.state.purchase.detail.customization_free_datetime
      ).format('MMMM')
      this.year = this.$moment(
        this.$store.state.purchase.detail.customization_free_datetime
      ).format('YYYY')
      this.time = this.$moment(
        this.$store.state.purchase.detail.customization_free_datetime
      ).format('HH:mm')
    }
  },
  methods: {
    openAirbnb() {
      this.showAirbnb = true
    },
    openStay() {
      this.showStay = true
    },
    finishOnboarding() {
      if (
        !this.$store.state.user.status.profile ||
        !this.$store.state.user.status.name
      )
        this.$root.$emit('openUserProfileOnboarding')
      else if (!this.$store.state.user.status.genres)
        this.$root.$emit('openUserGenresOnboarding')
      else if (!this.$store.state.user.status.artists)
        this.$root.$emit('openUserArtistsOnboarding')
    },
    openSignup() {
      this.$root.$emit('openSignup', 'thank-you')
    }
  }
}
</script>
